import { LOGIN_TYPE } from "../constants";

const loginReducer = (state = {
   sessionCode: '',
}, action) => {
   switch (action.type) {
      case LOGIN_TYPE.GET_OTP:
         return {
            ...state,
            sessionCode: action.payload
         };
      default:
         return state;
   }

}

export default loginReducer